import { Assignee, FilterDate } from './filters';

export type DefaultFiltersPrimitives = {
  work_types: Array<string>;
  statuses: Array<string>;
  date: string;
  assignee: Array<string>;
  // Optional to stay backward-compatible with default filters stored before priority existed.
  priorities?: Array<number>;
  // Optional to stay backward-compatible with default filters stored before route existed.
  routes?: Array<string>;
};

export class DefaultFilters {
  constructor(
    public readonly workTypes: Array<string>,
    public readonly statuses: Array<string>,
    public readonly assignee: Array<Assignee>,
    public readonly date: FilterDate,
    public readonly priorities: Array<number> = [],
    public readonly routes: Array<string> = []
  ) {}

  static fromPrimitives(primitives: DefaultFiltersPrimitives) {
    return new this(
      primitives.work_types,
      primitives.statuses,
      primitives.assignee as Array<Assignee>,
      primitives.date as FilterDate,
      primitives.priorities ?? [],
      primitives.routes ?? []
    );
  }

  toPrimitives(): DefaultFiltersPrimitives {
    return {
      work_types: this.workTypes,
      statuses: this.statuses,
      date: this.date,
      assignee: this.assignee,
      priorities: this.priorities,
      routes: this.routes,
    };
  }
}
